module.exports = __webpack_public_path__ + "img/cmvnf.dce50a74.png";